<template>
  <router-view></router-view>
</template>

<script>
import 'whatwg-fetch'
if (window.fetch === undefined) {
  window.fetch = fetch;
}
export default {
  name: 'App'
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
